import React, { useEffect, useState } from 'react';

import { useAppSelector } from '@core/hooks/appHooks';
import { selectVendor } from '@core/store/appSlice/appSlice';
import { demmiRequest } from '@helpers/app.helper';
import { DemmiFS } from '@subhanhabib/demmilib';

import OrdersList from './OrdersList';
import { NetworkService } from '@core/services/networkService/networkService';

const OrdersRefunded: React.FC = () => {
  const vendor = useAppSelector(selectVendor);
  const [orders, setOrders] = useState<DemmiFS.Order[]>([]);

  useEffect(() => {
    if (vendor) {
      demmiRequest(
        NetworkService.Orders.getOrdersWithRefunds(vendor.docID),
      ).then(o => {
        setOrders(DemmiFS.OrderHelper.sortByCollectionDate(o));
      });
    }
  }, [vendor]);

  const onClickRefresh = () => {
    if (vendor?.docID)
      demmiRequest(
        NetworkService.Orders.getOrdersWithRefunds(vendor.docID),
      ).then(o => {
        setOrders(DemmiFS.OrderHelper.sortByCollectionDate(o));
      });
  };

  return <OrdersList orders={orders} onClickRefresh={onClickRefresh} />;
};

export default OrdersRefunded;
